import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Tooltip } from '@nackle/paper';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import classNames from 'classnames';
import './in-context-help.less';
const InContextHelp = props => {
  const {
    type,
    title,
    children,
    className,
    style,
    drawerPlacement
  } = props;
  const [toggled, setToggle] = useState(false);
  const toggle = () => {
    setToggle(!toggled);
  };
  if (type === 'drawer') {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('in-context-help', 'in-context-help-drawer', className),
      style: style
    }, /*#__PURE__*/React.createElement(QuestionCircleTwoTone, {
      className: "question-circle-button",
      onClick: toggle
    }), /*#__PURE__*/React.createElement(Drawer, {
      style: {
        marginTop: 64
      },
      placement: drawerPlacement,
      title: title,
      visible: toggled,
      destroyOnClose: true,
      onClose: toggle
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 30
      }
    }, children)));
  } else if (type === 'tooltip') {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('in-context-help', 'in-context-help-tooltip', className),
      style: style
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: children
    }, /*#__PURE__*/React.createElement(QuestionCircleTwoTone, {
      className: "question-circle-button"
    })));
  }
};
InContextHelp.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  drawerPlacement: PropTypes.string
};
export default InContextHelp;
//# sourceMappingURL=in-context-help.js.map